import { forwardRef } from "react";
import { Button, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import l10n from "../../lib/l10n";
import useCustomModal from "../../store/custom-modal";
export const ButtonCloseMainModal = forwardRef(({ children, variant = 'button', ...rest }, ref) => {
  const {closeMainModal} = useCustomModal();
  
  if (variant === 'menuItem') {
    return (
      <MenuItem ref={ref} onClick={closeMainModal} {...rest}>
        <ListItemIcon>
          <CloseIcon />
        </ListItemIcon>
        <ListItemText primary={children || l10n?.ui_modal_action_close_text?.toString()} />
      </MenuItem>
    );
  }

  return (
    <Button
      ref={ref}
      startIcon={<CloseIcon />}
      onClick={closeMainModal}
      {...rest}
    >
      {children || l10n?.ui_modal_action_close_text?.toString()}
    </Button>
  );
});
